export default function formatPrice(price: number, currensySymbol?: string) {
  let res = new Intl.NumberFormat("ru-Ru").format(+price.toFixed(2));
  if (currensySymbol) {
    res = `${res} ${currensySymbol}`;
  }
  return res;
}

export function formatPriceTwoDigits(price: number, currencySymbol?: string) {
  let res = new Intl.NumberFormat("ru-RU", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(price);

  if (currencySymbol) {
    res = `${res} ${currencySymbol}`;
  }
  return res;
}
